<p-toast
  class="w-full! max-w-md! max-[767px]:right-auto! max-[767px]:left-1/2! max-[767px]:max-w-[calc(100vw-2rem)]! max-[767px]:-translate-x-1/2!"
  position="bottom-right"
>
  <ng-template let-message #message>
    @switch (message.severity) {
      @case ('success') {
        <span
          class="grid size-8 shrink-0 place-items-center self-center rounded-full bg-green-200! text-green-700!"
        >
          <i class="pi pi-check text-xs"></i>
        </span>
      }
      @case ('warn') {
        <span
          class="grid size-8 shrink-0 place-items-center self-center rounded-full bg-yellow-200! text-yellow-700!"
        >
          <i class="pi pi-exclamation-triangle text-xs"></i>
        </span>
      }
      @case ('error') {
        <span
          class="grid size-8 shrink-0 place-items-center self-center rounded-full bg-red-200! text-red-700!"
        >
          <i class="pi pi-times text-xs"></i>
        </span>
      }
      @default {
        <span
          class="bg-primary-200! text-primary-700! grid size-8 shrink-0 place-items-center self-center rounded-full"
        >
          <i class="pi pi-info-circle text-xs"></i>
        </span>
      }
    }

    <span class="min-w-0 flex-1 self-center">
      <span class="block text-sm font-semibold">{{ message.summary }}</span>
      <span class="block text-sm">{{ message.detail }}</span>
    </span>
  </ng-template>
</p-toast>
